export function countDown  (waitTime,doSomethingDuringCountDown,doSomethingAfterCountDown){
    if (waitTime > 0) {
      waitTime--;
        if(doSomethingDuringCountDown){
             doSomethingDuringCountDown()
        }    
      } else {
          if(doSomethingAfterCountDown){
              doSomethingAfterCountDown()
          }  
          return;
      }
      setTimeout(() => {
          countDown(waitTime,doSomethingDuringCountDown,doSomethingAfterCountDown);
      }, 1000);
}

  // 判断是否为安卓手机
  export function isAndroid() {
    var u = navigator.userAgent
    if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
      return true
    } else {
      return false
    }
  }